import {logError} from '../utils/logger';

import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    window.newrelic && window.newrelic.noticeError(error);
    logError(error);
  }

  render() {
    // You can render any custom fallback UI
    return this.props.children;
  }
}

export default ErrorBoundary;
